import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { CountType } from 'enums'

import PostSearchDataGuards from '../share/guards/PostSearchDataGuards'
import PreSearchDataGuards from '../share/guards/PreSearchDataGuards'
import Table from '../share/Table'
import RunSearchEffect from '../share/RunSearchEffect'
import useSelectedInsights from '../hooks'
import { TagsWidgetsType } from '../types'
import InsightModal from '../share/InsightModal'

const SocialWebTagsWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<TagsWidgetsType>(widgetId)
  const {
    handleRowClick,
    selectedInsights,
    handleCloseModal,
    isModalOpen,
    detailSetting,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <PreSearchDataGuards widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <PostSearchDataGuards widgetId={widgetId}>
            <Table widgetId={widgetId} onRowClick={handleRowClick} />
          </PostSearchDataGuards>
        </RunSearchEffect>
      </PreSearchDataGuards>
      <InsightModal
        widgetSettingWithSelection={widgetSettingWithSelection}
        open={isModalOpen}
        title={widgetSetting?.name}
        countType={widgetSetting.countType || CountType.POSTS}
        selectedInsights={selectedInsights}
        onClose={handleCloseModal}
        detailSetting={detailSetting}
        forceNotScale
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebTagsWidget
